import { Route, RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumb';

const RequestsLayout = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RequestsLayout" */ '../layout/layout');
const RequestList = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RequestList" */ '../pages/request-list/request-list');
const ChooseRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ChooseRequest" */ '../pages/choose-request/choose-request');
const FinancialClaimRequestCreate = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FinancialClaimRequestCreate" */ '../pages/financial-claim/request-create/request-create');
const FinancialClaimRequestDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FinancialClaimRequestDetails" */ '../pages/financial-claim/request-details/request-details');
const JTPVerificationForm = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "JTPVerificationForm" */ '../pages/verification/verification-form/verification-form');
const JTPVerificationResult = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "JTPVerificationResult" */ '../pages/verification/verification-result/verification-result');
const JTPAddDelegatorResult = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "JTPVerificationResult" */ '../pages/delegator-result/confirm-result');
export const routes: RouteConfig[] = [
  {
    path: '/requests',
    component: RequestsLayout,
    children: [
      {
        path: '',
        name: 'RequestList',
        component: RequestList,
        meta: {
          highlighted: true,
          breadcrumb: Breadcrumbs.requestList,
          eventName: 'Request list page',
        },
      },
      {
        path: 'choose-request',
        name: 'ChooseRequest',
        component: ChooseRequest,
        meta: {
          highlighted: true,
          breadcrumb: Breadcrumbs.chooseRequest,
          eventName: 'Choose request page',
        },
      },
      {
        path: 'financial-claim',
        name: 'FinancialClaimRequestCreate',
        component: FinancialClaimRequestCreate,
        meta: () => ({
          highlighted: true,
          breadcrumb: Breadcrumbs.financialClaimRequest(),
          eventName: 'Financial claim request create page',
        }),
      },
      {
        path: 'financial-claim/:id',
        name: 'FinancialClaimRequestDetails',
        component: FinancialClaimRequestDetails,
        meta: (route: Route) => ({
          highlighted: true,
          breadcrumb: Breadcrumbs.financialClaimRequestDetails(route),
          eventName: 'Financial claim request details page',
        }),
      },
      {
        path: 'verify',
        name: 'JTPVerificationForm',
        component: JTPVerificationForm,
        meta: (route: Route, isLoggedIn: boolean) => ({
          highlighted: true,
          breadcrumb: Breadcrumbs.verification(route, isLoggedIn),
          eventName: 'JTP verification form page',
        }),
      },
      {
        path: 'verify/:id',
        name: 'JTPVerificationResult',
        component: JTPVerificationResult,
        props: true,
        meta: (route: Route, isLoggedIn: boolean) => ({
          highlighted: true,
          breadcrumb: Breadcrumbs.verificationResult(route, isLoggedIn),
          eventName: 'JTP verification result page',
        }),
      },
      {
        path: 'confirm-delegator/:id',
        name: 'JTPAddDelegatorResult',
        component: JTPAddDelegatorResult,
        props: true,
        meta: () => ({
          highlighted: true,
          breadcrumb: Breadcrumbs.addDelegatorDetails(),
          eventName: 'JTP verification result page',
        }),
      },
    ],
  },
];
